
import DashboardIcon from '../../assets/icons/dashboard.svg';
import ShippingIcon from '../../assets/icons/shipping.svg';
import ProductIcon from '../../assets/icons/product.svg';
import UserIcon from '../../assets/icons/user.svg';




const sidebar_menu = [
    {
        id: 1,
        icon: DashboardIcon,
        path: '/',
        title: 'Inicio',
    },
    {
        id: 2,
        icon: ProductIcon,
        path: '/activities',
        title: 'Ver Reportes',
    },
    {
        id: 3,
        icon: ShippingIcon,
        path: '/activity',
        title: 'Nuevo Reporte',
    },
    {
        id: 4,
        icon: UserIcon,
        path: '/lots',
        title: 'Villas',
    }
]


export default sidebar_menu;